export default function HeroSection({ config }) {
    return (
        <div className="max-w-[1110px] mx-auto px-4 mb-8">
            <h1 className="text-[28px] md:text-[42px] font-bold text-brand-dark leading-[1.1] tracking-[-0.42px] mb-4 md:mb-6">
                {config.title} <br/>
                <span className="text-gradient">{config.titleHighlight}</span>
            </h1>
            <div className="flex flex-col gap-4 md:flex-row md:gap-6">
                {(config.features || []).map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                        <div
                            className="w-6 h-6 rounded-md bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange flex items-center justify-center">
                            <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                <path d="M1 5L4.5 8.5L11 1" stroke="white" strokeWidth="2" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span className="text-lg font-medium text-[#221D2D] leading-[130%] tracking-[-0.18px]">
                            {feature}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
